import React from 'react';
import './index.scss';

import { Redirect } from "react-router-dom";
import {connect} from 'react-redux';
import {bindActionCreators, Dispatch} from 'redux';
import {ApplicationState} from '../../store';
import {User} from '../../store/ducks/user/types';
import * as UserActions from '../../store/ducks/user/actions';
import {Param} from '../../store/ducks/param/types';
import * as ParamActions from '../../store/ducks/param/actions';
import {Cart} from '../../store/ducks/cart/types';
import * as CartActions from '../../store/ducks/cart/actions';
import Api from '../../services/api';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import UserSidebar from '../../components/UserSidebar';
import DetailsItem from '../../components/DetailsItem';

import { Button, Row, Col, Accordion, Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faConciergeBell } from '@fortawesome/free-solid-svg-icons';
import { faClone } from '@fortawesome/free-regular-svg-icons';

// import Prod1 from '../../assets/Images/image-3.png'
// import Prod2 from '../../assets/Images/image-2.png'
// import Prod3 from '../../assets/Images/image-3.png'

interface StateProps { 
  user: User;
  param: Param;
  cart: Cart;
} 

interface DispatchProps {
  doLogin(user: User): void;
  setParam(param: Param): void;
  drop(rowid: string): void;
}

interface OwnProps {
  item: any;
}

type Props = StateProps & DispatchProps & OwnProps;

class Checkout extends React.Component<Props> {

  api: any = null;
  state: any = null;

  textArea: any;

  constructor(props) {
    super(props);
    this.api = new Api();
    this.state = {
      redirect: null,
      isLoading: false,
      statusPedido: 1,
      showMore: false,
      pedidoAberto: false,
      modalDetails: false,
      copySuccess: '',
      email: "",
      senha: "",
      hasError: false,
      hasErrorTitle: "",
      hasErrorMsg: "",
      quantity: 1,

      pedidos: false,
    }
  }

  // componentDidMount () {
  //   const self = this; 
  //   if (( self.props.user ) && ( self.props.user.status === true )) { // SE USUARIO ESTIVER LOGADO REDIRECIONA PARA OUTRA PAGINA
  //     self.setState({redirect: '/'});
  //   }
  // }

  handleChange = (event) => {
    this.setState({quantity: event.target.value});
  }

    // Funções repetidas do Produto. Melhorar
    // Funções não estao funcionando. Ver "state" e "row.qty"
    private IncreaseItem = () => {
      this.setState(prevState => {
        if (this.state.quantity < 9999) {
          return {
            quantity: this.state.quantity + 1
          }
        }
  
        else {
          return null;
        }
      });
    }
  
    private DecreaseItem = () => {
      this.setState(prevState => {
        if (this.state.quantity > 0) {
          return {
            quantity: this.state.quantity - 1
          }
        }
  
        else {
          return null;
        }
      });
    }

  private getCartTotal () {
    const self = this;
    let total = 0.00;
    for ( var i = 0; i < self.props.cart.produtos.length; i++ ) {
      total += self.props.cart.produtos[i].price * self.props.cart.produtos[i].qty;
    }
    return total;
  }

  private handleDropProduto (item: any) {
    const self = this;

    if ( !item )
      return;

    let confirmDrop = window.confirm(`Deseja realmente excluir o produto ${item.nome} do seu carrinho?`);

    if ( confirmDrop )
      self.props.drop(item.rowid);
  }

  private handleShowMore() {
    this.setState({showMore: !this.state.showMore});
  }

  private async getOrderItems (pedido: number) {
    const self = this;

    self.setState({isLoadingItems: true});

    try {
      const {data} = await self.api.get(`/order/${pedido}/items`);

      if ( data.status === false ) {
        throw new Error('Nenhum produto encontrado');
      } else {
        self.setState({
          pedidoCurrentItems: data.msg
        });
      }

    } catch (e) {
      console.error(e);
      self.setState({pedidoCurrentItems: []});
    } finally {
      self.setState({isLoadingItems: false});
    }
  }

  // Controla classe aplicada ao status do pedido na tela
  private orderStatus (s) {
    if (s === 8) {
      return 'pedido-cancelado';
    }

    else if (s === 6) {
      return 'pedido-concluido';
    }

    else if (s === 5) {
      return 'pedido-enviado';
    }
  }

  copyToClipboard = (e) => {
    this.textArea.select();
    document.execCommand('copy');
    e.target.focus();
    this.setState({ copySuccess: 'Copiado!' });
  };

  handleTooltipHide () {
    this.setState({
      copySuccess: ''
    });
  }

  render () {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }

    return (
      <>
        <Header/>

        <section className="meus-pedidos">
          <Row className="mx-0 meus-pedidos-row">
            <Col lg={4} xl={3} className="meus-pedidos-sidebar">
              <UserSidebar/>
            </Col>

            <Col lg={8} xl={9} className="meus-pedidos-col">
                <h2> Meus Pedidos </h2>

              { 
              !this.state.pedidos ?
                  <>
                    <article className="pedidos-vazio">
                      <h4> 0 <FontAwesomeIcon icon={faConciergeBell} /> </h4>
                      <h4> Você ainda não fez nenhum pedido </h4>
                      <p> Navegue por nossa loja e encontre seus produtos favoritos </p>
                    </article>
                  </>
              :
                <>
                  <select name="filtrar pedidos" className="filtrar-pedidos">
                    <option value="Pendente"> Pendente </option>
                    <option value="Pendente"> Aguardando Confirmação </option>
                    <option value="Pendente"> Entregue </option>
                    <option value="Pendente"> Cancelado </option>
                  </select>
                  <Accordion defaultActiveKey="0" className="meus-pedidos-container">
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.setState({pedidoAberto: !this.state.pedidoAberto})} className="pedido-header">
                        Pedido #1
                        <FontAwesomeIcon icon={this.state.pedidoAberto ? faChevronDown : faChevronUp}/>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body as={Row} className="mx-0 pedido-content">
                          <div className="pedido-id">
                            <p> <strong> Itens: </strong> </p> 
                            <div>
                              <span className="pedido-qtd"> 2 </span>
                              <p className="pedido-nome"> Carne de frango desviada do monte do pleemsd dsndfsin ssd </p>
                            </div>
                            <div>
                              <span className="pedido-qtd"> 1 </span>
                              <p className="pedido-nome"> Bisteca Suina </p>
                            </div>
                            <div>
                              <span className="pedido-qtd"> 1 </span>
                              <p className="pedido-nome"> Torresmo Seara </p>
                            </div>
                            <div>
                              <span className="pedido-qtd"> 1 </span>
                              <p className="pedido-nome"> Molho de pimenta Domakoski </p>
                            </div>
                            <div>
                              <span className="pedido-qtd"> 1 </span>
                              <p className="pedido-nome"> Chuleta </p>
                            </div>
                            <div>
                              <span className="pedido-qtd"> 500g </span>
                              <p className="pedido-nome" title="Carne de frango desviada arne de grangoosoaisj"> Carne de frango desviada arne de frango desviada arne de frango desviada arne de frango desviada arne de frango desviada</p>
                            </div>
                          </div>
                          <Col sm={6} className="pl-0">
                            <div className="pedido-item">
                              <p> <strong> Data: </strong> 27/08/1902 </p> 
                              <p> <strong> Valor: </strong> R$ 29,90 </p> 
                            </div>
                          </Col>
                          <Col sm={6} className="pl-0">
                            <div className="pedido-item">
                              <p> <strong> Pagamento: </strong> Dinheiro </p> 
                              <p> <strong className={`pedido-status ${(this.orderStatus(this.state.statusPedido))}`}> Status: </strong> pai ta on </p> 
                            </div>
                          </Col>
                          <h5 onClick={() => {this.setState({modalDetails: !this.state.modalDetails})}}> Clique para visualizar </h5>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </>
              }

            </Col>
          </Row>
        </section>
        
        <Footer/>

        <Modal
        show={this.state.modalDetails}
        onHide={() => this.setState({modalDetails: !this.state.modalDetails, pedidoCurrent: null, pedidoCurrentItems: null})}
        dialogClassName="detalhes-pedido-dialog"
        className="px-0 detalhes-pedido"
        size={'sm'}
        // centered={true}
        >
          {
            // !this.state.pedidoCurrent ? 
            this.state.pedidoCurrent ? 
            <>
              <Modal.Header closeButton className="detalhes-pedido-header">
                <span style={{display: "flex" , alignItems: "flex-start"}}>
                  <p> Detalhes da compra </p>
                </span>
              </Modal.Header>
              <Modal.Body className="detalhes-pedido-body">
                <div className="alert alert-danger">
                  Nenhum pedido selecionado.
                </div>
              </Modal.Body>
            </>
            :
            <>
              <Modal.Header closeButton className="detalhes-pedido-header">
                <span style={{display: "flex", flexDirection: "column", alignItems: "flex-start"}}>
                  <Modal.Title> 
                    {/* #{this.state.pedidoCurrent.PEDIDO} */}
                    #1
                  </Modal.Title>
                  <p> Detalhes da compra </p>
                </span>
              </Modal.Header>

              <Modal.Body className="detalhes-pedido-body">
                <h6> Dados do pedido </h6>
                <span className="d-flex align-items-center">
                  <p> <strong> Data: </strong> </p>
                  {/* <p> {this.state.pedidoCurrent.DATA} {this.state.pedidoCurrent.HORA} </p> */}
                  <p> 12/02/1012 <small className="mx-1" style={{color: '#666'}}> • </small> 12:23 </p>
                </span>
                <span className="d-flex align-items-center">
                  <p> <strong> Forma de pagamento: </strong> </p>
                  {/* <p> {Diversos.getStatusFormapg(this.state.pedidoCurrent.FORMAPG)} </p> */}
                  <p> abraços </p>
                </span>
                <span className="d-flex align-items-center">
                  <p> <strong> Status do pedido: </strong> </p>
                  <p> passa bem </p>
                  {/* <p> {Diversos.getStatusTitulo(this.state.pedidoCurrent.STATUS)} </p> */}
                </span>

                <hr className="w-100"/>

                <h6> Dados da entrega </h6>
                <span className="d-flex align-items-center">
                  <p> <strong> Modo de envio: </strong> </p>
                  {/* <p> {this.state.pedidoCurrent.ENTREGA} </p> */}
                  <p> em pé </p>
                </span>
                <span className="d-flex align-items-center">
                  <p> <strong> Bairro: </strong> </p>
                  {/* <p> {this.state.pedidoCurrent.clienteDados.bairro} </p> */}
                  <p> Funny </p>
                </span>
                <span className="d-flex align-items-center">
                  <p> <strong> CEP: </strong> </p>
                  {/* <p> {Diversos.maskCEP(this.state.pedidoCurrent.clienteDados.cep)} </p> */}
                  <p> 91370001 </p>
                </span>
                <span className="d-flex align-items-center">
                  <p> <strong> Cidade: </strong> </p>
                  {/* <p> {this.state.pedidoCurrent.clienteDados.cidade} </p> */}
                  <p> Curitiba </p>
                </span>
                <span className="d-flex align-items-center">
                  <p> <strong> Prazo de envio: </strong> </p>
                  {/* <p> {this.state.pedidoCurrent.DTENTREGA} </p> */}
                  <p> Já </p>
                </span>

                {/* {
                  this.state.pedidoCurrent.CODCORREIO && */}
                  <span className="rastreamento">
                    <p> <strong> Código de Rastreamento: </strong> </p>
                    <span> 
                      {/* <textarea> {this.state.pedidoCurrent.CODCORREIO} </textarea> */}

                      <textarea aria-readonly readOnly ref={(textarea) => this.textArea = textarea}> SL 123456789 BR 1123 </textarea>

                      {
                        document.queryCommandSupported('copy') &&
                        <OverlayTrigger
                        placement={window.innerWidth > 576 ? 'right' : 'top'}
                        delay={{show: 200, hide: 300}}
                        overlay={
                          <Tooltip id="tooptip-feedback">
                            { this.state.copySuccess || "Copiar código"}
                          </Tooltip>
                        }>
                          <FontAwesomeIcon icon={faClone} flip="vertical" onClick={this.copyToClipboard}/>
                        </OverlayTrigger>
                      }

                    </span>
                  </span>
                {/* } */}
                
                <hr className="w-100"/>

                <h6> Produtos </h6>
                {
                  this.state.isLoadingItems ?
                  <i className="fas fa-spin fa-spinner"></i>
                  :
                  ((!this.state.pedidoCurrentItems) || (this.state.pedidoCurrentItems.length <= 0)) ?
                  <div className="alert alert-warning">Nenhum produto localizado para este pedido</div>
                  :
                  this.state.pedidoCurrentItems.map((row, index) => (
                    <DetailsItem item={row} key={index}/>
                  ))
                }
              </Modal.Body>

              <Modal.Footer className="detalhes-pedido-footer">
                <div className="detalhes-total">
                  <span className="d-flex align-items-center">
                    <p> <strong> Subtotal: </strong> </p>
                    <p> R$ 90,99 </p>
                    {/* <p> {`R$ ${Diversos.number_format(this.getTotalPedido(this.state.pedidoCurrent),2,",","")}`} </p> */}
                  </span>
                  <span className="d-flex align-items-center">
                    <p> <strong> Frete: </strong> </p>
                    {/* <p> {`R$ ${Diversos.number_format(this.state.pedidoCurrent.FRETE,2,",","")}`} </p> */}
                    <p> R$ 5,90 </p>
                  </span>
                  <span className="d-flex align-items-center">
                    <p> <strong> Total da compra: </strong> </p>
                    <p> R$ 90,99 </p>
                    {/* <p> {`R$ ${Diversos.number_format( (this.getTotalPedido(this.state.pedidoCurrent) + this.state.pedidoCurrent.FRETE) ,2,",","")}`} </p> */}
                  </span>
                </div>

                <Button variant="secondary" onClick={() => this.setState({modalDetails: !this.state.modalDetails, pedidoCurrent: null, pedidoCurrentItems: null})}> Fechar </Button>

              </Modal.Footer>
            </>
          }
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data,
  cart: state.cart.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({...UserActions, ...ParamActions, ...CartActions}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Checkout);
